























































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import { sharedInstance as authService } from '@/services/AuthService'
import { sharedInstance as analytics } from '@/services/AnalyticsService'

import ProjectLimitsMixin from '@/mixins/ProjectLimitsMixin'
import ShowInvitesMixin from '@/mixins/ShowInvitesMixin'

import FeatureLimitsDisplay from '@/components/FeatureLimitsDisplay.vue'

import {
	createNewProject,
	createNewPackage,
	createNewTemplate
} from '@/database/projects'

import SelectTemplateDisplay from '@/components/SelectTemplateDisplay.vue'

import Fuse from 'fuse.js'

@Component({
	components: {
		SelectTemplateDisplay,
		FeatureLimitsDisplay
	}
})
export default class Dashboard extends Mixins(ProjectLimitsMixin, ShowInvitesMixin)
{
	private name = ''
	private isLoading = false
	private templateSearch = ''
	private selectedTemplate: PublishedTemplate | null = null
	private filteredTemplates: Array<PublishedTemplate> = []

	private fuse!: Fuse<PublishedTemplate, Fuse.FuseOptions<PublishedTemplate>>

	get buttonClasses()
	{
		return {
			button: true,
			'is-primary': true,
			'is-fullwidth': true,
			'is-medium': true,
			'is-loading': this.isLoading
		}
	}

	get templates(): Array<PublishedTemplate>
	{
		return this.$store.getters['templates/templates']
	}

	get projectType()
	{
		return this.$route.query.type || 'project'
	}

	get canCreate()
	{
		if (!this.canCreateProject)
		{
			return false
		}

		switch (this.projectType)
		{
			default:
			case 'project':
				return this.name && this.selectedTemplate

			case 'package':
			case 'template':
				return !!this.name
		}
	}

	get sessionToken()
	{
		const token: string = this.$store.getters['auth/sessionToken']
		return token
	}

	@Watch('templateSearch')
	private onSearchChanged(newVal)
	{
		if (!this.fuse || !newVal)
		{
			return this.templates
		}

		this.filteredTemplates = this.fuse.search(newVal)
	}

	@Watch('templates')
	private onTemplatesChanged(newVal)
	{
		this.filteredTemplates = this.templates
		this.fuse.setCollection(newVal)
	}

	mounted()
	{
		this.filteredTemplates = this.templates
		this.fuse = new Fuse(this.templates, {
			keys: [
				'name', 'description', 'keywords'
			]
		})

		analytics.setCurrentScreen('new_project')
	}

	private handleTemplateSelected(template)
	{
		this.selectedTemplate = template
	}

	private async handleCreateProject()
	{
		if (!this.canCreate)
		{
			return
		}

		if (!this.name)
		{
			return
		}

		if (!authService.isSignedIn || !authService.user)
		{
			this.$router.push('/')
			return
		}

		this.isLoading = true

		const type = this.projectType
		const userId = authService.user.uid

		switch (type)
		{
			default:
			case 'project':
			{
				const ref = await createNewProject(
					this.name,
					userId,
					this.selectedTemplate
				)
				const baseUrl = process.env.VUE_APP_STUDIO_URL
				let url = `${baseUrl}/${ref.id}`
				if (this.sessionToken)
				{
					url += `?token=${this.sessionToken}`
				}
				window.location.replace(url)
				break
			}

			case 'package':
			{
				const ref = await createNewPackage(this.name, userId)
				const baseUrl = process.env.VUE_APP_TEMPLATE_BUILDER_URL
				window.location.replace(`${baseUrl}/${ref.id}`)
				break
			}

			case 'template':
			{
				const ref = await createNewTemplate(this.name, userId)
				const baseUrl = process.env.VUE_APP_TEMPLATE_BUILDER_URL
				window.location.replace(`${baseUrl}/${ref.id}`)
				break
			}
		}
	}
}
